/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  getSubscription() {
    return axios.get(`${this.baseUrl()}/subscription`);
  }

  cancelSubscription() {
    return axios.post(`${this.baseUrl()}/subscription/cancel`);
  }

  resumeSubscription() {
    return axios.post(`${this.baseUrl()}/subscription/resume`);
  }
}

export default new AccountAPI();
